import { ROLE_ORDER } from './constants'

/**
 * Returns the highest available role of a users enrolled in a course
 */
export function getHighestEnrollmentRoleId(enrolments) {
  // We don't want to modify the passed array
  const tmp = [...enrolments];
  tmp.sort((a, b) => {
    const baseRoleCompare = ROLE_ORDER[a.type] - ROLE_ORDER[b.type];
    if (baseRoleCompare !== 0) {
      return baseRoleCompare;
    }
    // If the base role is the same just sort by the role ID so we have a predictable result
    return a.role_id - b.role_id;
  })
  return tmp.pop()?.role_id;
}

export function uniqueArr(array) {
  const seen = new Set();
  return array.filter(el => {
    const duplicate = seen.has(el.id);
    seen.add(el.id);
    return !duplicate;
  });
}